import {
  getISODate,
  timestampComparator,
} from "../../../../../../shared/util/common/helper";

import { formatReasonCodes, getCashClaimCompletedStatus } from "../util";

export const fundingHistoryColumnDefinitions = [
  {
    id: "requestId",
    header: "Fund Request or Claim ID",
    cell: (e) => (e.cashClaimId ? e.cashClaimId : e.fundRequestId),
    sortingField: "requestId",
  },
  {
    id: "assignedTo",
    header: "Assigned To",
    cell: (e) => e.assignedTo,
    sortingField: "assignedTo",
  },
  {
    id: "actualUser",
    header: "Actual User",
    cell: (e) => e.actualUser,
    sortingField: "actualUser",
  },
  {
    id: "action",
    header: "Action",
    cell: (e) => e.action,
    sortingField: "action",
  },
  {
    id: "date",
    header: "Date",
    cell: (e) => getISODate(e.date),
    sortingField: "date",
    sortingComparator: (e1, e2) => timestampComparator(e1.date, e2.date),
  },
  {
    id: "partnerComments",
    header: "Comments from Partner",
    cell: (e) => e.partnerComments,
  },
  {
    id: "commentsToPartner",
    header: "Comments to the Partner",
    cell: (e) => e.commentsToPartner,
  },
  {
    id: "reasonCodes",
    header: "Rejection Reasons",
    cell: (e) => formatReasonCodes(e.reasonCodes),
  },
  {
    id: "internalComments",
    header: "Internal Comments",
    cell: (e) => e.internalComments,
  },
  {
    id: "stage",
    header: "Stage",
    cell: (e) => e.stage,
  },
  {
    id: "claimCompleted",
    header: "Claim Completed",
    cell: (e) => getCashClaimCompletedStatus(e.cashClaimCompleted),
  },
];

export const searchableColumns = [
  "requestId",
  "assignedTo",
  "actualUser",
  "action",
  "date",
  "partnerComments",
  "commentsToPartner",
  "internalComments",
  "stage",
  "claimCompleted",
];
